// extracted by mini-css-extract-plugin
export default {"vstack":"style_vstack__fBe6C"};